import * as ko from './ko'
import * as en from './en'
import * as ja from './ja'

const locales = {
  ko,
  en,
  ja
}

export default locales